import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "wouter";

const navLinks = [
  { href: "/about", label: "Story" },
  { href: "/talent-search", label: "Talent Search" },
  { href: "/the-path-forward", label: "The Path Forward" },
  { href: "/legal", label: "Legal" },
];

export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [location] = useLocation();

  const linkClassName = (href: string) =>
    `text-sm font-medium transition-colors ${
      location === href ? "text-[var(--vf-forest)]" : "text-[rgba(24,34,24,0.7)] hover:text-[var(--vf-forest)]"
    }`;

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-black/5 bg-[rgba(245,241,232,0.86)] backdrop-blur-xl">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:px-6 lg:px-8">
        <Link href="/" className="flex flex-col leading-none">
          <span className="text-lg font-semibold text-[var(--vf-forest)]">Vermont Forest</span>
          <span className="text-[10px] uppercase tracking-[0.28em] text-[rgba(24,34,24,0.5)]">
            Thoughts into things
          </span>
        </Link>

        <nav className="hidden items-center gap-5 md:flex" aria-label="Primary navigation">
          <Link href="/" className={linkClassName("/")} aria-current={location === "/" ? "page" : undefined}>
            Home
          </Link>
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={linkClassName(link.href)}
              aria-current={location === link.href ? "page" : undefined}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 text-[var(--vf-ink)] md:hidden"
          aria-label={isOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={isOpen}
          aria-controls="mobile-site-navigation"
          onClick={() => setIsOpen((open) => !open)}
        >
          {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {isOpen && (
        <nav
          id="mobile-site-navigation"
          className="border-t border-black/5 bg-[var(--vf-paper)] px-5 py-4 md:hidden"
          aria-label="Mobile navigation"
        >
          <div className="mx-auto flex max-w-6xl flex-col gap-3">
            <Link
              href="/"
              className={linkClassName("/")}
              aria-current={location === "/" ? "page" : undefined}
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={linkClassName(link.href)}
                aria-current={location === link.href ? "page" : undefined}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
